module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-season-coming-soon u-relative u-flex u-flex-jc--center u-flex-fd--column u-flex-ai--center"
  }, [_c('h1', {
    staticClass: "c-season-coming-soon__title u-uppercase u-color--white",
    domProps: {
      "innerHTML": _vm._s(_vm.titleStylized)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-season-coming-soon__countdown u-marg-t-xs u-flex u-flex-ai--center u-flex-jc--center u-color--gray-light"
  }, [_c('div', {
    staticClass: "c-season-coming-soon__countdown__item u-relative u-flex u-flex-fd--column u-flex-ai--center u-flex-jc--center"
  }, [_c('span', {
    staticClass: "c-season-coming-soon__countdown__item__border u-absolute u-pos-tr"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.countdown.daysString))]), _vm._v(" "), _c('span', {
    staticClass: "c-season-coming-soon__countdown__item__text u-marg-t-xxxs u-uppercase u-color--gray-blue"
  }, [_vm._v("days")])]), _vm._v(" "), _c('div', {
    staticClass: "c-season-coming-soon__countdown__item u-relative u-flex u-flex-fd--column u-flex-ai--center u-flex-jc--center"
  }, [_c('span', {
    staticClass: "c-season-coming-soon__countdown__item__border u-absolute u-pos-tr"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.countdown.hoursString))]), _vm._v(" "), _c('span', {
    staticClass: "c-season-coming-soon__countdown__item__text u-marg-t-xxxs u-uppercase u-color--gray-blue"
  }, [_vm._v("hours")])]), _vm._v(" "), _c('div', {
    staticClass: "c-season-coming-soon__countdown__item u-relative u-flex u-flex-fd--column u-flex-ai--center u-flex-jc--center"
  }, [_c('span', {
    staticClass: "c-season-coming-soon__countdown__item__border u-absolute u-pos-tr"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.countdown.minutesString))]), _vm._v(" "), _c('span', {
    staticClass: "c-season-coming-soon__countdown__item__text u-marg-t-xxxs u-uppercase u-color--gray-blue"
  }, [_vm._v("minutes")])]), _vm._v(" "), _c('div', {
    staticClass: "c-season-coming-soon__countdown__item u-relative u-flex u-flex-fd--column u-flex-ai--center u-flex-jc--center"
  }, [_c('span', [_vm._v(_vm._s(_vm.countdown.secondsString))]), _vm._v(" "), _c('span', {
    staticClass: "c-season-coming-soon__countdown__item__text u-marg-t-xxxs u-uppercase u-color--gray-blue"
  }, [_vm._v("seconds")])])]), _vm._v(" "), (_vm.content.text.length > 0 && _vm.content.text.trim() !== '') ? _c('div', {
    staticClass: "c-season-coming-soon__description o-content u-marg-t-xl u-align-center u-color--gray-text",
    domProps: {
      "innerHTML": _vm._s(_vm.content.text)
    }
  }) : _vm._e(), _vm._v(" "), _c('app-btn', {
    staticClass: "c-btn--secondary u-marg-t-lg u-align-center u-inline-block@lg u-marg-b-xs@lg",
    attrs: {
      "to": _vm.content.linkUrl,
      "target": "_self"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.linkLabel)
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ada9102"}!./src/scripts/components/app-season-coming-soon/template.html
// module id = 905
// module chunks = 0